import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=66fdae86"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fdae86')) {
      api.createRecord('66fdae86', component.options)
    } else {
      api.reload('66fdae86', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=66fdae86", function () {
      api.rerender('66fdae86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/content/Loader.vue"
export default component.exports